// extracted by mini-css-extract-plugin
export default {"wrapper":"News_wrapper__OvYpY","container":"News_container__lt-L+","newsCards":"News_newsCards__QxwHi"};